/**
 * Runtime bug-report capture configuration (set by BugReportCaptureProvider).
 */

export type BugReportMode = 'off' | 'manual' | 'auto'

export interface BugReportCaptureConfig {
  mode: BugReportMode
  captureConsole: boolean
  captureApiErrors: boolean
  autoReportFrontend: boolean
}

const DEFAULT_CONFIG: BugReportCaptureConfig = {
  mode: 'off',
  captureConsole: false,
  captureApiErrors: false,
  autoReportFrontend: false,
}

let runtimeConfig: BugReportCaptureConfig = { ...DEFAULT_CONFIG }

export function setBugReportCaptureConfig(config: Partial<BugReportCaptureConfig>): void {
  runtimeConfig = { ...runtimeConfig, ...config }
}

export function getBugReportCaptureConfig(): BugReportCaptureConfig {
  return runtimeConfig
}

export function isCaptureActive(): boolean {
  const c = runtimeConfig
  return c.mode !== 'off' && (c.captureConsole || c.captureApiErrors || c.mode === 'auto')
}

export function shouldCaptureConsole(): boolean {
  const c = runtimeConfig
  return c.captureConsole || c.mode === 'auto'
}

export function shouldCaptureApiErrors(): boolean {
  const c = runtimeConfig
  return c.captureApiErrors || c.mode === 'auto'
}

export function isAutoMode(): boolean {
  return runtimeConfig.mode === 'auto' && runtimeConfig.autoReportFrontend
}
